<template>
  <div>
    <div class="single-apply-area">
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          v-loading="loading"
      >
        <el-row>

          <el-col :span="24" class="mb15 mt20">
            <h4 style="margin: 0; font-weight: 500; color: #409EFF; text-align: left; padding-left: 20px;">
              企业信息
            </h4>
            <div style="height: 1px; background-color: #e4e7ed; margin-top: 8px;"></div>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传材料" style="margin-bottom: 0px !important;">
              <template slot="label">
                <div class="fz14 top-text" style="width: 100%">
                  <div class="mb5">
                    <span style="color: red" class="mr5">*</span>上传材料
                  </div>
                  <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
                  <div class="fc-407FFF pointer" @click="downAuth">下载授权书</div>
                </div>
              </template>

              <div class="upload-image">
                <el-form-item label-width="0px" prop="businessLicenseId"
                              v-if="!disbaleList">
                  <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
                  <el-upload
                      ref="businessLicenseId"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 2)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('businessLicenseId')">

                      <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
                      <img
                          class="icon-check"
                          v-if="imageLicenseId"
                          @click.stop="checkImage('license')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img
                          v-if="!imageLicenseId"
                          src="@/assets/login/image-card-official.png"
                          alt
                      />
                      <span v-if="!imageLicenseId" class="fz14 fc9">上传单位营业执照</span>
                    </div>

                  </el-upload>
                </el-form-item>
                <el-form-item label-width="0px" prop="legaPersonFrontId"
                              v-if="!disbaleList">
                  <el-input style="display: none" v-model="ruleForm.legaPersonFrontId"></el-input>
                  <el-upload
                      ref="legaPersonFrontId"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 5)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('legaPersonFrontId')">
                      <img class="image-card" v-if="legaPersonFront" :src="legaPersonFront" alt/>
                      <img
                          class="icon-check"
                          v-if="legaPersonFront"
                          @click.stop="checkImage('front')"
                          src="@/assets/login/icon-check-img.png"
                      />
                      <img v-if="!legaPersonFront" src="@/assets/login/image-card-people.png" alt/>
                      <span v-if="!legaPersonFront" class="fz14 fc9">上传法人身份证人像面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item label-width="0px" prop="legaPersonReserveId"
                              v-if="!disbaleList">
                  <el-input style="display: none" v-model="ruleForm.legaPersonReserveId"></el-input>
                  <el-upload
                      ref="legaPersonReserveId"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 6)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('legaPersonReserveId')">
                      <img class="image-card" v-if="legaPersonReserve" :src="legaPersonReserve" alt/>
                      <img
                          class="icon-check"
                          v-if="legaPersonReserve"
                          @click.stop="checkImage('reserve')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!legaPersonReserve" src="@/assets/login/image-card-emblem.png" alt/>
                      <span v-if="!legaPersonReserve" class="fz14 fc9">上传法人身份证国徽面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item label-width="0px" prop="authorizationId">
                  <el-input style="display: none" v-model="ruleForm.authorizationId"></el-input>
                  <el-upload
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 3)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <img class="image-card" v-if="imageAuthorization" :src="imageAuthorization" alt/>
                    <img
                        class="icon-check"
                        v-if="imageAuthorization"
                        @click.stop="checkImage('auth')"
                        src="@/assets/login/icon-check-img.png"
                        alt
                    />
                    <img v-if="!imageAuthorization" style="width: 140px;" src="@/assets/login/image-card-auth.png" alt/>
                    <span v-if="!imageAuthorization" class="fz14 fc9"
                    >上传企业授权书照片</span>
                  </el-upload>
                </el-form-item>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="businessCreditCode" label="信用代码">
              <el-input
                  :disabled="disbaleList"
                  @blur="checkCode"
                  v-model="ruleForm.businessCreditCode"
                  placeholder="请输入信用代码"
              >
              </el-input>
            </el-form-item>
            <div class="prompt">请对比信用代码识别的准确性</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="businessName" label="单位名称">
              <el-input
                  :disabled="disbaleList"
                  v-model="ruleForm.businessName"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
            <div class="prompt">请对比单位名称识别的准确性</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="legalPersonName" label="法人">
              <el-input
                  :disabled="disbaleList"
                  v-model="ruleForm.legalPersonName"
                  placeholder="请输入法人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="legalPersonIdCard" label="法人身份证号">
              <el-input
                  :disabled="disbaleList"
                  v-model="ruleForm.legalPersonIdCard"
                  placeholder="请输入法人身份证号"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 企业信息 -->

          <!--          <el-col :span="12">-->
          <!--            <el-form-item prop="name" label="法人">-->
          <!--              <el-input-->
          <!--                  :disabled="disbaleList"-->
          <!--                  v-model="ruleForm.name"-->
          <!--                  placeholder="请输入法人姓名"-->
          <!--              ></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="12">-->
          <!--            <el-form-item prop="idCard" label="法人身份证号">-->
          <!--              <el-input-->
          <!--                  :disabled="disbaleList"-->
          <!--                  v-model="ruleForm.idCard"-->
          <!--                  placeholder="请输入法人身份证号"-->
          <!--              ></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!-- 经办人信息 -->
          <el-col :span="24" class="mb15">
            <h4 style="margin: 0; font-weight: 500; color: #409EFF; text-align: left; padding-left: 20px;">
              印章管理员信息
            </h4>
            <div style="height: 1px; background-color: #e4e7ed; margin-top: 8px;"></div>
          </el-col>
          <el-col :span="24">
            <el-form-item style="margin-bottom: 0px !important;">
              <template slot="label">
                <div class="fz14 top-text" style="width: 100%">
                  <div class="mb5">
                    <span style="color: red" class="mr5">*</span>上传材料
                  </div>
                  <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
                </div>
              </template>

              <div class="upload-image">
                <el-form-item label-width="0px" prop="idCardFrontId">
                  <el-input style="display: none" v-model="ruleForm.idCardFrontId"></el-input>
                  <el-upload
                      ref="idCardFrontId"
                      class="avatar-uploader"
                      style="width: 220px"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 0)"
                      :on-change="onChangeFront"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('idCardFrontId')">
                      <img class="image-card" v-if="imageUrlFront" :src="imageUrlFront" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlFront"
                          @click.stop="checkImage('front')"
                          src="@/assets/login/icon-check-img.png"
                      />
                      <img v-if="!imageUrlFront" src="@/assets/login/image-card-people.png" alt/>
                      <span v-if="!imageUrlFront" class="fz14 fc9">上传印章管理员身份证人像面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item label-width="0px" prop="idCardReserveId">
                  <el-input style="display: none" v-model="ruleForm.idCardReserveId"></el-input>
                  <el-upload
                      ref="idCardReserveId"
                      class="avatar-uploader"
                      style="width: 220px"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 1)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('idCardReserveId')">
                      <img class="image-card" v-if="imageUrlReserve" :src="imageUrlReserve" alt/>
                      <img
                          class="icon-check"
                          v-if="imageUrlReserve"
                          @click.stop="checkImage('reserve')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!imageUrlReserve" src="@/assets/login/image-card-emblem.png" alt/>
                      <span v-if="!imageUrlReserve" class="fz14 fc9">上传印章管理员身份证国徽面照片</span>
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item label-width="0px" prop="checkId">
                  <el-input style="display: none" v-model="ruleForm.checkId"></el-input>
                  <el-upload
                      ref="scene"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 4)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%"
                         @click.stop="changeUpload('scene')">
                      <img class="image-card" v-if="imageScene" :src="imageScene" alt/>
                      <img
                          class="icon-check"
                          v-if="imageScene"
                          @click.stop="checkImage('scene')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!imageScene && !ruleForm.checkId" style="width: 140px;"
                           src="@/assets/login/image-card-face.png" alt/>
                      <span v-if="!imageScene && !ruleForm.checkId" class="fz14 fc9"
                      >上传印章管理员现场照片</span>

                      <img v-if="!imageScene && ruleForm.checkId" src="@/assets/finished.png" alt/>
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="name" label="印章管理员">
              <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入印章管理员姓名"
              ></el-input>
            </el-form-item>
            <div class="prompt">请填写印章管理员的姓名</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="idCard" label="印章管理员身份证号">
              <el-input
                  v-model="ruleForm.idCard"
                  placeholder="请输入印章管理员身份证号"
              ></el-input>
            </el-form-item>
            <div class="prompt">请填写印章管理员的身份证号</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="telephone" label="手机号码(账号)">
              <el-input
                  type="number"
                  v-model="ruleForm.telephone"
                  :maxlength="11"
                  placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="12">-->
          <!--            <el-form-item class="captcha-item" prop="smsCode" label="验证码">-->
          <!--              <el-input-->
          <!--                  v-model="ruleForm.smsCode"-->
          <!--                  placeholder="请输入短信验证码"-->
          <!--              ></el-input>-->
          <!--              <div v-if="!hadSend" class="get-cap" @click="getCaptcha">获取验证码</div>-->
          <!--              <div v-if="hadSend" class="get-cap">{{ count }}s重新获取</div>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="12">
            <el-form-item prop="email" label="邮箱">
              <el-input
                  :disabled="disbaleList"
                  type="text"
                  v-model="ruleForm.email"
                  placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>

          <!--          <el-col :span="12">-->
          <!--            <el-form-item prop="password" style="position: relative" label="登录密码">-->
          <!--              <el-input-->
          <!--                  v-model="ruleForm.password"-->
          <!--                  placeholder="请输入登录密码"-->
          <!--              ></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!-- <el-col :span="12">
            <el-form-item prop="inviteCode" label="邀请码">
              <el-input v-model="ruleForm.inviteCode" placeholder="请输入邀请码"></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="24" class="mb15">
            <h4 style="margin: 0; font-weight: 500; color: #409EFF; text-align: left; padding-left: 20px;">
              经办人信息
            </h4>
            <div style="height: 1px; background-color: #e4e7ed; margin-top: 8px;"></div>
          </el-col>

          <el-col :span="24">
            <el-form-item style="margin-bottom: 0px !important;">
              <template slot="label">
                <div class="fz14 top-text" style="width: 100%">
                  <div class="mb5">
                    <span style="color: red" class="mr5">*</span>上传材料
                  </div>
                </div>
              </template>

              <div class="upload-image">
                <el-form-item label-width="0px" prop="agentCheckId">
                  <el-input style="display: none" v-model="ruleForm.agentCheckId"></el-input>
                  <el-upload
                      ref="agentCheck"
                      class="avatar-uploader"
                      multiple
                      :show-file-list="false"
                      :before-upload="(e) => handleBeforeUpload(e, 7)"
                      :on-change="onChangeReserve"
                      action="/"
                      accept="image/*"
                  >
                    <div class="flex-dir-center-center" style="width: 100%;height: 100%">
                      <img class="image-card" v-if="agentCheck" :src="agentCheck" alt/>
                      <img
                          class="icon-check"
                          v-if="agentCheck"
                          @click.stop="checkImage('agentCheck')"
                          src="@/assets/login/icon-check-img.png"
                          alt
                      />
                      <img v-if="!agentCheck && !ruleForm.agentCheckId" style="width: 140px;"
                           src="@/assets/login/image-card-face.png" alt/>
                      <span v-if="!agentCheck && !ruleForm.agentCheckId" class="fz14 fc9"
                      >上传经办人现场照片</span>

                      <img v-if="!agentCheck && ruleForm.agentCheckId" src="@/assets/finished.png" alt/>
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="agentName" label="经办人">
              <el-input
                  v-model="ruleForm.agentName"
                  placeholder="请输入经办人姓名"
              ></el-input>
            </el-form-item>
            <div class="prompt">请填写经办人的姓名</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="agentIdCard" label="经办人身份证号">
              <el-input
                  v-model="ruleForm.agentIdCard"
                  placeholder="请输入经办人身份证号"
              ></el-input>
            </el-form-item>
            <div class="prompt">请填写经办人的身份证号</div>
          </el-col>

        </el-row>
        <el-form-item label-width="0">
          <el-button class="next-button" type="primary" @click="submitForm('ruleForm')">确认无误，下一步</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <check-example ref="checkRef"></check-example>
    <verify-code ref="verifyRef" @getMessage="getMessage"></verify-code>
    <el-image-viewer v-if="isShowPics" :on-close="closeViewer" :url-list="srcList"/>
    <upload-change v-if="visible" :visible.sync="visible" :uploadType="uploadType" @uploadFiles="uploadFiles"/>
    <face-check ref="faceRef" @subPersonSeal="getCheckId"></face-check>
    <id-card-complete ref="IdCardComplete" @faceRecognition="faceRecognition"/>
  </div>
</template>

<script>
import verifyCode from "@/components/VerifyCode.vue";
import CheckExample from "@/pages/register/components/CheckExample.vue";
import Cookie from "js-cookie";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import UploadChange from "@/pages/customerEnterprise/components/uploadChange.vue";
import Identify from "@/pages/authentication/comonents/identify.vue";
import FaceCheck from "@/pages/customerEnterprise/components/FaceCheck.vue";
import IdCardComplete from "@/pages/customerEnterprise/components/idCardComplete.vue";

export default {
  name: "OfficialApply",
  components: {IdCardComplete, FaceCheck, Identify, UploadChange, CheckExample, verifyCode, ElImageViewer},
  data() {
    var validPass = (rule, value, callback) => {
      let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入设置您的登录密码"));
      } else if (!reg.test(value)) {
        callback(
            new Error(
                "密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"
            )
        );
      } else {
        callback();
      }
    };
    var validIdCard = (rule, value, callback) => {
      // let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      // let reg1 = /^[A-Z]{1,2}[0-9]{6}\\(?[0-9A]\\)?$/;
      // let reg1 = /^[A-Z]?[A-Z]{1}\\d{6}\\([0-9A]{1}\\)$/;
      var patternMainLand = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;//大陆
      var patternHongkong = /^((\s?[A-Za-z])|([A-Za-z]{2}))\d{6}(\([0−9aA]\)|[0-9aA])$/;//香港
      var patternTaiwan = /^[a-zA-Z][0-9]{9}$/;//台湾
      var patternMacao = /^[1|5|7][0-9]{6}\([0-9Aa]\)/;//澳门
      var reg = /^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$/;  //护照（包括香港和澳门）
      var reg1 = /^[EeKkGgDdSsPpHh]\d{8}$/
      if (value === "") {
        callback(new Error("请输入身份证号"));
      } else if (!patternMainLand.test(value) && !patternHongkong.test(value) && !patternTaiwan.test(value) && !patternMacao.test(value) && !reg.test(value) && !reg1.test(value) && !this.disbaleList) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === "") {
        callback(new Error("请输入电子邮箱"));
      } else if (!emailRegex.test(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    }
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      imageUrlFront: "",
      imageUrlReserve: "",
      legaPersonFront: "",
      legaPersonReserve: "",
      imageLicenseId: "",
      imageAuthorization: "",
      imageScene: "",
      agentCheck: "",
      isShowPics: false,
      visible: false,
      srcList: [],
      hadSend: false,
      count: 60,
      timer: null,
      loading: false,
      ruleForm: {
        name: undefined,
        idCard: undefined,
        email: undefined,
        telephone: undefined,
        password: undefined,
        smsCode: undefined,
      },
      // 判断是否禁用的列表
      disbaleList: false,
      rules: {
        // businessCreditCode: [{required: true, validator: validCode, trigger: "blur"}],
        businessCreditCode: [{required: true, message: "请输入信用代码", trigger: "blur"}],
        businessName: [
          {required: true, message: "请输入正确的单位名称", trigger: "blur"},
        ],
        name: [{required: true, message: "请输入印章管理员姓名", trigger: "blur"}],
        idCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        agentName: [{required: true, message: "请输入经办人姓名", trigger: "blur"}],
        agentIdCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        legalPersonName: [{required: true, message: "请输入法人姓名", trigger: "blur"}],
        legalPersonIdCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
        password: [{required: true, validator: validPass, trigger: "blur"}],
        // smsCode: [{required: true, message: "请输入短信验证码", trigger: "blur"}],
        email: [
          {required: true, validator: validateEmail, trigger: "blur"},
        ],
        idCardFrontId: [
          {
            required: true,
            message: "请上传经办人身份证人像面照片",
            trigger: "change",
          },
        ],
        idCardReserveId: [
          {
            required: true,
            message: "请上传经办人身份证国徽面照片",
            trigger: "change",
          },
        ],
        legaPersonFrontId: [
          {
            required: true,
            message: "请上传法人身份证人像面照片",
            trigger: "change",
          },
        ],
        legaPersonReserveId: [
          {
            required: true,
            message: "请上传法人身份证国徽面照片",
            trigger: "change",
          },
        ],
        businessLicenseId: [
          {
            required: true,
            message: "请上传单位营业执照",
            trigger: "change",
          },
        ],
        // authorizationId: [
        //   {
        //     required: true,
        //     message: "请上传企业授权书照片",
        //     trigger: "change",
        //   },
        // ],
        checkId: [
          {
            required: true,
            message: "请上传法人现场照片",
            trigger: "change",
          },
        ],
        agentCheckId: [
          {
            required: true,
            message: "请上传经办人现场照片",
            trigger: "change",
          },
        ],
      },
      raw: null,

      uploadUrl: "http://192.168.130.193:8081" + process.env.VUE_APP_API_BASE_URL + "/online/apply/uploadImg",
      uploadType: ''
    };
  },
  methods: {
    faceRecognition(idCard) {
      this.$refs.faceRef.show({...this.ruleForm, idCard: idCard}, "经办人");
    },
    getCheckId(checkId) {
      this.$set(this.ruleForm, "checkId", checkId);
    },
    uploadFiles(e) {
      if (e == 0) {
        this.getEncryptStr()
      } else if (e == 1 || e == 3) {
        this.$refs[this.uploadType].$refs['upload-inner'].handleClick()
      } else if (e == 2) {
        if (this.disbaleList) {
          this.$refs.IdCardComplete.show(this.ruleForm.idCard)
        } else {
          this.$refs.faceRef.show(this.ruleForm, "法人");
        }
      }
      this.visible = false
    },
    changeUpload(e) {
      if (e == 'idCardFrontId' || e == 'businessLicenseId' || e == 'idCardReserveId' || e == 'legaPersonReserveId' || e == 'legaPersonFrontId') {
        if (typeof GSESC === 'object') {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      } else if (e == 'scene') {
        if (this.ruleForm.name && this.ruleForm.idCard) {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      } else if (e == 'uploadFiles') {
        if (this.ruleForm.name && this.ruleForm.idCard) {
          this.uploadType = e
          this.visible = true
        } else {
          this.$refs[e].$refs['upload-inner'].handleClick()
        }
      }
      // this.getEncryptStr()
    },
    getEncryptStr() {
      let _this = this
      this.$http.get(this.$api.customerEnterprise.getEncryptStr).then((res) => {
        if (res.data.code == 200) {
          let params = {
            authData: res.data.msg
          }
          GSESC.api.unLock(JSON.stringify(params), function (res) {
            _this.getCameraPic()
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    caOUKeyLogin() {
      let _this = this
      GSESC.api.caOUKeyLogin(function (result) {
        console.log(result)
        if (result.status == 1) {
          let params = {
            serialNumber: result.data.uid,
            signedValue: result.data.signedValue
          }
          GSESC.api.unLock(JSON.stringify(params), function (res) {
            _this.getCameraPic()
          });
        }
        //
      });
    },
    getCameraPic() {
      let _this = this
      GSESC.api.getCameraPic("jpg", _this.uploadUrl, function (result) {
        if (result.status == 1) {
          let base = _this.urlToBase64(result.data[0].fileUrl)
          base.then(res => {
            let position = res.indexOf("base64");
            let lastIndex = position * 1 + 7;
            let base64 = res.slice(lastIndex);
            if (_this.uploadType == 'idCardFrontId') {
              _this.$set(_this, 'imageUrlFront', res)
              _this.request(base64, 0)
            } else if (_this.uploadType == 'businessLicenseId') {
              _this.$set(_this, 'imageLicenseId', res)
              _this.request(base64, 2)
            }
          })
        }
      });
    },
    async urlToBase64(imageUrl) {
      return new Promise((resolve, reject) => {
        let canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' // 解决Canvas.toDataURL 图片跨域问题
        img.src = imageUrl
        img.onload = function () {
          canvas.height = img.height
          canvas.width = img.width
          ctx.fillStyle = '#fff' // canvas背景填充颜色默认为黑色
          ctx.fillRect(0, 0, img.width, img.height)
          ctx.drawImage(img, 0, 0) // 参数可自定义
          const dataURL = canvas.toDataURL('image/jpeg', 1) // 获取Base64编码
          resolve(dataURL)
          canvas = null // 清除canvas元素
          img = null // 清除img元素
        }
        img.onerror = function () {
          reject(new Error('Could not load image at ' + imageUrl))
        }
      })
    },
    urlTobase(url) {
      var imgDom = document.createElement('img');
      imgDom.src = url
      imgDom.crossOrigin = 'anonymous' //支持跨域
      console.log(imgDom)
      var canvas = document.createElement("canvas");
      canvas.width = imgDom.width;
      canvas.height = imgDom.height;
      console.log(canvas)
      var ctx = canvas.getContext("2d");
      ctx.drawImage(imgDom, 0, 0, imgDom.width, imgDom.height);
      console.log(ctx)
      var dataURL = canvas.toDataURL("image/png", 1);
      return dataURL
    },
    haveSaveBlur(lable, value) {
      let list = JSON.parse(sessionStorage.getItem('FilingData'))
      if (list) {
        list[lable] = value
      }
    },
    // 获取信息
    getFilingData() {
      this.loading = true
      let list = JSON.parse(sessionStorage.getItem('FilingData'))
      this.$set(this, 'ruleForm', list.ruleForm)
      this.$set(this, 'imageUrlFront', list.imageUrlFront)
      this.$set(this, 'imageUrlReserve', list.imageUrlReserve)
      this.$set(this, 'imageLicenseId', list.imageLicenseId)
      this.$set(this, 'imageAuthorization', list.imageAuthorization)
      this.$set(this, 'legaPersonReserve', list.legaPersonReserve)
      this.$set(this, 'legaPersonFront', list.legaPersonFront)
      this.$set(this, 'imageScene', list.imageScene)
      this.$set(this, 'agentCheck', list.agentCheck)
      this.$set(this, 'disbaleList', list.disbaleList)
      this.loading = false
    },
    // 保存信息
    handleSave() {
      sessionStorage.removeItem('FilingData')
      let list = {
        ruleForm: this.ruleForm,
        imageUrlFront: this.imageUrlFront,
        imageUrlReserve: this.imageUrlReserve,
        imageLicenseId: this.imageLicenseId,
        imageAuthorization: this.imageAuthorization,
        legaPersonReserve: this.legaPersonReserve,
        legaPersonFront: this.legaPersonFront,
        imageScene: this.imageScene,
        agentCheck: this.agentCheck,
        disbaleList: this.disbaleList,
      }
      // 存放备案数据
      sessionStorage.setItem('FilingData', JSON.stringify(list))
    },
    // 重置
    handleReset() {
      this.ruleForm = {
        name: undefined,
        idCard: undefined,
        email: undefined,
        telephone: undefined,
        password: undefined,
        smsCode: undefined,
      }
      this.imageUrlFront = ''
      this.imageUrlReserve = ''
      this.legaPersonFront = ''
      this.legaPersonReserve = ''
      this.imageLicenseId = ''
      this.imageAuthorization = ''
      this.imageScene = ''
      this.agentCheck = ''
      this.$refs.ruleForm.resetFields()
      this.disbaleList = false
      sessionStorage.removeItem('FilingData')
    },
    closeViewer() {
      this.isShowPics = false;
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.subPersonSeal()
          // this.$emit('update:type', 2);
        }
      });
    },
    subPersonSeal() {
      this.loading = true;
      this.$http.post(this.$api.customerEnterprise.submitBusinessSeal, this.ruleForm).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          Cookie.set("businessCreditCode", res.data.data.businessCreditCode);
          Cookie.set("agentName", this.ruleForm.agentName);
          Cookie.set("agentIdCard", this.ruleForm.agentIdCard);
          this.$auth.setKqUserId(res.data.data.userId);
          this.$emit('changeType', 2, res.data.data.pinCode ? true : false);
          sessionStorage.removeItem('FilingData')
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    checkCode() {
      let value = this.ruleForm.businessCreditCode
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      this.disbaleList = false
      if (value === "" || !reg.test(value)) {
        return
      }
      this.$http.post(this.$api.customerEnterprise.getOnlineUserInfo, {orgCode: value}).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data
          this.$set(this.ruleForm, "businessName", data.businessName);
          this.$set(this.ruleForm, "businessCreditCode", data.businessCreditCode);
          this.$set(this.ruleForm, "legalPersonName", data.legalPersonName);
          this.$set(this.ruleForm, "legalPersonIdCard", data.legalPersonIdCard);
          this.$set(this.ruleForm, "telephone", data.telephone);
          this.$set(this.ruleForm, "email", data.email);
          this.disbaleList = true
        } else {
          this.disbaleList = false
        }
      })
    },
    request(base, type) {
      let types = type
      if (type == 5) {
        types = 0
      }
      if (type == 6) {
        types = 1
      }
      if (type == 7) {
        types = 4
      }
      let params = {
        businessCode: this.ruleForm.businessCreditCode ? this.ruleForm.businessCreditCode : null,
        type: '' + types,
        imageBase64: base,
      };
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "name", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "idCard", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "idCardFrontId", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "idCardReserveId", res.data.data.imageId);
          } else if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "businessName", res.data.data.businessName);
            }

            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "businessCreditCode", res.data.data.businessCode);
              this.checkCode()
              this.$refs.ruleForm.clearValidate()
            }
          } else if (type == 3) {
            this.$set(this.ruleForm, "authorizationId", res.data.data.imageId);
          } else if (type == 4) {
            this.$set(this.ruleForm, "checkId", res.data.data.imageId);
          } else if (type == 5) {
            if (res.data.data.name) {
              this.$set(this.ruleForm, "legalPersonName", res.data.data.name);
            }
            if (res.data.data.idCard) {
              this.$set(this.ruleForm, "legalPersonIdCard", res.data.data.idCard);
            }
            this.$set(this.ruleForm, "legaPersonFrontId", res.data.data.imageId);
          } else if (type == 6) {
            this.$set(this.ruleForm, "legaPersonReserveId", res.data.data.imageId);
          } else if (type == 7) {
            this.$set(this.ruleForm, "agentCheckId", res.data.data.imageId);
          }
          if (res.data.data.errMsg) {
            this.$message.warning(res.data.data.errMsg);
          } else {
            this.$message.success(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
          if (type == 0) {
            this.imageUrlFront = "";
          } else if (type == 1) {
            this.imageUrlReserve = "";
          } else if (type == 2) {
            this.imageLicenseId = "";
          } else if (type == 3) {
            this.imageAuthorization = "";
          } else if (type == 4) {
            this.imageScene = "";
          } else if (type == 5) {
            this.legaPersonFront = "";
          } else if (type == 6) {
            this.legaPersonReserve = "";
          } else if (type == 7) {
            this.agentCheckId = "";
          }
        }
        this.loading = false;
      });
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else if (flag == "license") {
        this.srcList.push(this.imageLicenseId);
      } else if (flag == "reserve") {
        this.srcList.push(this.imageUrlReserve);
      } else if (flag == "auth") {
        this.srcList.push(this.imageAuthorization);
      } else if (flag == "agentCheck") {
        this.srcList.push(this.agentCheck)
      } else {
        this.srcList.push(this.imageScene);
      }
      this.isShowPics = true;
    },
    getMessage(param) {
      let params = param;
      params.telephone = this.ruleForm.telephone;
      // params.type = 'register';
      this.loading = true;
      this.$http.post(this.$api.register.sendSMSCode, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.hadSend = true;
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              if (this.timer) {
                this.hadSend = false;
                clearInterval(this.timer);
              }
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleBeforeUpload(file, type) {
      console.log(type)
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          // 管理员身份证人像面照片
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          // 印章管理员身份证国徽面照片
          this.imageUrlReserve = e.target.result;
        } else if (type == 2) {
          // 单位营业执照
          this.imageLicenseId = e.target.result;
        } else if (type == 3) {
          // 企业授权书照片
          this.imageAuthorization = e.target.result;
        } else if (type == 4) {
          // 印章管理员现场照片
          this.imageScene = e.target.result;
        } else if (type == 5) {
          // 法人身份证人像面照片
          this.legaPersonFront = e.target.result;
        } else if (type == 6) {
          // 法人身份证国徽面照片
          this.legaPersonReserve = e.target.result;
        } else if (type == 7) {
          // 经办人现场照片
          this.agentCheck = e.target.result
        }
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },
    getCaptcha() {
      if (!this.ruleForm.telephone) {
        this.$message.warning("请先输入手机号码");
        return;
      }
      this.$refs.verifyRef.show();
    },
    downAuth() {
      top.window.location.href = this.baseUrl + this.$api.register.downAuth
    },
    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-form-item__error {
  background-color: #ffffff;
  width: 100%
}

.prompt {
  margin-top: -28px;
  font-size: 12px;
  text-align: left;
  padding-left: 150px;
  color: #409EFF;
  margin-bottom: 11px;
}

.single-apply-area {
  margin-left: 10px;
  margin-right: 10px;

  .upload-image {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .top-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
  }

  .captcha-item {
    position: relative;
  }

  .get-cap {
    position: absolute;
    right: 20px;
    top: 0px;
    color: #407fff;
    cursor: pointer;
  }

  .next-button {
    width: 350px;
    font-size: 16px;
    padding: 11px 20px !important;
    margin-top: 40px;
    box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
  }
}

.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
